import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Collapse} from 'react-collapse';
import {Alert, Divider, Form, Input, Space} from 'antd';
import {
  StyledRequestPaymentModal,
  StyledRequestPaymentModalDate,
  StyledRequestPaymentModalVendor,
  StyledRequestPaymentModalAmount
} from './StyledRequestPaymentModal';
import SpinSmall from '../../../SpinSmall';
import {amountHelpers, dateHelpers, formHelpers} from '../../../../utils/helpers';

const {Item} = Form;

const defaultFormValues = { payment_request_reason: '' };

const RequestPaymentModal = ({
  handleOk,
  handleCancel,
  loading = false,
  invoice,
  open,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'budgets']);
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const comment = Form.useWatch('payment_request_reason', {form});

  const handleAfterClose = () => {
    form.resetFields();
    if (error) setError(null);
  }

  const handleSubmit = (data) => {
    handleOk?.({
      data,
      errorCallback: (response) => formHelpers.handleFormErrors({form, t, setError, response})
    });
  }

  return (
    <StyledRequestPaymentModal
      afterClose={handleAfterClose}
      cancelButtonProps={{size: 'middle'}}
      forceRender
      okButtonProps={{
        disabled: comment === '',
        size: 'middle',
        type: 'primary',
      }}
      okText={t('submit')}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      open={open}
      title={`${t('request')} ${t('payment')}`}
      width={510}
      {...rest}
    >
      <SpinSmall spinning={loading}>
        <Space size='middle' direction='vertical' className='w-100'>
          <div className='d-flex justify-space-between align-items-center'>
            <Space size='small' direction='vertical'>
              <StyledRequestPaymentModalDate>
                {dateHelpers.getDateWithMonth(invoice?.date, 'DD MMM YYYY, hh:mm')}
              </StyledRequestPaymentModalDate>
              <StyledRequestPaymentModalVendor>
                {invoice?.vendor}
              </StyledRequestPaymentModalVendor>
            </Space>
            <StyledRequestPaymentModalAmount>
              {amountHelpers.getAmountWithCurrencyCode(invoice?.amount, undefined, invoice?.currency)}
            </StyledRequestPaymentModalAmount>
          </div>
          <Divider size='small' />
          <Form
            initialValues={defaultFormValues}
            form={form}
            layout='vertical'
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Item
              label={t('reason')}
              name='payment_request_reason'
              rules={[{required: true, message: t('validation.fieldIsRequired')}]}
              required
            >
              <Input.TextArea
                placeholder={t('placeholderTemplates.enter', {name: t('reason').toLowerCase()})}
                size='large'
                rows={4}
                style={{ height: 70 }}
              />
            </Item>
          </Form>
        </Space>
        <Collapse isOpened={Boolean(error)}>
          <Alert message={error} type='error' showIcon />
        </Collapse>
      </SpinSmall>
    </StyledRequestPaymentModal>
  );
}

RequestPaymentModal.propTypes = {
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  loading: PropTypes.bool,
  name: PropTypes.string,
  open: PropTypes.bool.isRequired,
}

export default RequestPaymentModal;
